import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

const selectedSidePanelManualFaultEvent = io.union([
  io.strict({
    type: io.literal("details"),
    tab: io.union([io.literal("fault"), io.literal("history")]),
  }),
  io.strict({
    type: io.literal("comments"),
  }),
  io.strict({
    type: io.literal("activity"),
  }),
  io.intersection([
    io.strict({
      type: io.literal("edit"),
    }),
    io.partial({
      focusField: io.keyof({
        actionIdentified: null,
      }),
    }),
  ]),
]);

export const useSelectedSidePanelManualFaultEvent = createGlobalState({
  storage: "session",
  key: "useSelectedSidePanelManualFaultEvent2",
  type: selectedSidePanelManualFaultEvent,
  defaultValue: {
    type: "details",
    tab: "fault",
  },
  scoped: true,
});
export type SelectedSidePanelManualFaultEvent = io.TypeOf<typeof selectedSidePanelManualFaultEvent>;
